<template>
    <div class="empty-rooms-page">
      <!-- Sidebar for Filters -->
      <div class="sidebar">
        <h3 class="filter-title">Filters</h3>

       <!-- Country Dropdown -->
<select v-model="filters.country" @change="applyFilters" class="filter-select">
    <option value="">Select Country</option>
    <option value="Kenya">Kenya</option>
    <option value="Other Country">Other Country</option> <!-- Add other countries as needed -->
  </select>

  <!-- County Dropdown -->
  <select v-model="filters.county" @input="applyFilters" class="filter-select" :disabled="!filters.country">

    <option value="">Select County</option>
    <option v-for="county in selectedCounties" :key="county.code" :value="county.name">
      {{ county.name }}
    </option>
  </select>

  <!-- Other Filters -->
  <input v-model="filters.location" placeholder="Location" class="filter-input" @input="applyFilters">
  <input type="text" v-model="filters.city" placeholder="City" class="filter-input" @input="applyFilters">
  <input type="number" v-model="filters.price" placeholder="Max Price" class="filter-input" @input="applyFilters">

  <!-- Room Type Dropdown -->
  <select v-model="filters.room_size" @change="applyFilters" class="filter-select">
    <option value="">Select Room Type</option>
    <option value="single">Single</option>
    <option value="double">Double</option>
    <option value="1 bedroom">1 Bedroom</option>
    <option value="2 bedroom">2 Bedroom</option>
    <option value="3 bedroom">3 Bedroom</option>
    <option value="other">Other</option>
  </select>

  <input v-model="filters.apartment_name" placeholder="Apartment Name" class="filter-input" @input="applyFilters">
  <input type="number" v-model="filters.apartment_id" placeholder="Apartment ID" class="filter-input" @input="applyFilters">

  <select v-model="filters.type" class="filter-select" @change="applyFilters">
    <option value="">Select Type</option>
    <option value="rental">Rental</option>
    <option value="commercial">Commercial</option>
    <option value="BnB">Bnb</option>
  </select>

  <button @click="getCurrentLocation" class="btn-location">Use My Location</button>

  <!-- Button to Apply Filters -->
  <button @click="applyFilters" class="btn-apply-filters">Apply Filters</button>
</div>

      <!-- Main content area -->
      <main class="main-content">
        <!-- Title for Available Rooms -->
        <h2 class="units-title">Available Units ({{ filteredRooms.length }} out of {{ rooms.length }})</h2>
        <div v-if="filteredRooms.length > 0" class="room-list">
          <!-- Rooms List -->
          <div v-for="room in filteredRooms" :key="room.id" class="room-card">
            <!-- Room Carousel -->
            <div class="room-carousel">
              <img :src="getRoomImage(room.image)" alt="Room Image" class="room-image">
              <div class="carousel-info">
                <span>{{ room.watchlist_count }} watchlist</span>
                <span>{{ room.booked_count }} booked</span>
              </div>
            </div>

            <!-- Room Info -->
            <div class="room-info">
              <p class="room-price">Price: <span class="price-value">{{ room.price }}</span></p>
              <p class="room-location">Location: {{ room.apartments[0].location }}</p>
              <p class="room-location">Size: {{ room.room_size }}</p>
            </div>

            <!-- Room Actions (Add to Watchlist, Book Room) -->
            <div class="room-actions">
              <button @click="addToWatchlist(room.id)" class="btn-watchlist">
                <i class="fas fa-heart"></i> Add to Watchlist
              </button>
              <button @click="bookRoom(room.id)" class="btn-book">
                <i class="fas fa-book"></i> Book
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <p>No rooms found</p>
        </div>

        <!-- Pagination -->
        <div class="pagination">
          <button @click="previousPage" :disabled="currentPage === 1" class="btn-pagination">Previous</button>
          <span class="current-page">{{ currentPage }}</span>
          <button @click="nextPage" :disabled="currentPage === totalPages" class="btn-pagination">Next</button>
        </div>

        <!-- Available Services -->
        <section class="available-services">
          <h2 class="services-title">Available Services</h2>
          <div class="service-list">
            <!-- Display services here -->
          </div>
          <!-- Pagination for services -->
          <div class="pagination">
            <button @click="previousPage" :disabled="currentPage === 1" class="btn-pagination">Previous</button>
            <span class="current-page">{{ currentPage }}</span>
            <button @click="nextPage" :disabled="currentPage === totalPages" class="btn-pagination">Next</button>
          </div>
        </section>

        <!-- Map Section -->
        <div class="map" id="map"></div>
      </main>
    </div>
  </template>


  <script>
  import axios from 'axios';

  export default {
  data() {
    return {
      rooms: [], // This should hold all rooms to filter
      filters: {
        country: 'Kenya', // Default country
        county: '',
        location: '',
        city: '',
        price: null,
        room_size: '',
        apartment_name: '',
        apartment_id: null,
        type: '',
        lat: null,
        lng: null,
      },
    counties: {
      Kenya: [
        { name: 'Mombasa', code: 'MSA' },
  { name: 'Kwale', code: 'KWL' },
  { name: 'Kilifi', code: 'KLF' },
  { name: 'Tana River', code: 'TRV' },
  { name: 'Lamu', code: 'LMU' },
  { name: 'Taita–Taveta', code: 'TVT' },
  { name: 'Garissa', code: 'GRS' },
  { name: 'Wajir', code: 'WJR' },
  { name: 'Mandera', code: 'MDR' },
  { name: 'Marsabit', code: 'MRS' },
  { name: 'Isiolo', code: 'ISL' },
  { name: 'Meru', code: 'MRU' },
  { name: 'Tharaka-Nithi', code: 'TNT' },
  { name: 'Embu', code: 'EMB' },
  { name: 'Kitui', code: 'KTU' },
  { name: 'Machakos', code: 'MCK' },
  { name: 'Makueni', code: 'MKN' },
  { name: 'Nyandarua', code: 'NDR' },
  { name: 'Nyeri', code: 'NYR' },
  { name: 'Kirinyaga', code: 'KRG' },
  { name: 'Murang\'a', code: 'MRG' },
  { name: 'Kiambu', code: 'KMB' },
  { name: 'Turkana', code: 'TRK' },
  { name: 'West Pokot', code: 'WPK' },
  { name: 'Samburu', code: 'SBR' },
  { name: 'Trans-Nzoia', code: 'TNZ' },
  { name: 'Uasin Gishu', code: 'UGS' },
  { name: 'Nairobi', code: 'NAI' },
  { name: 'Nakuru', code: 'NAK' },
  { name: 'Kericho', code: 'KEC' },
  { name: 'Bomet', code: 'BOM' },
  { name: 'Narok', code: 'NAR' },
  { name: 'Kajiado', code: 'KAJ' },
  { name: 'Kisii', code: 'GSI' },
  { name: 'Vihiga', code: 'VIG' },
  { name: 'Bungoma', code: 'BUM' },
  { name: 'Busia', code: 'BUS' },
  { name: 'Homa Bay', code: 'HBB' },
  { name: 'Migori', code: 'MIG' },
  { name: 'Siaya', code: 'SIA' },
  { name: 'Kisumu', code: 'KSM' },
      ],
      OtherCountry: [
          // Add counties specific to other countries here
        ],
      },
      selectedCounties: [], // To hold the counties for the selected country
      items: [], // Original items to filter
      filteredItems: [],
      currentPage: 1,
      totalPages: 1,
      loading: false,
      map: null,
      markers: [],
      defaultImage: "/img/default-room-image.jpg",
    };
  },
  watch: {
    'filters.country'(newCountry) {
      // Update selected counties based on the selected country
      this.selectedCounties = this.counties[newCountry] || [];
      // Reset the county filter
      this.filters.county = '';
      // Reapply filters
      this.applyFilters();
    }
  },

    computed: {
      filteredRooms() {
        return this.rooms.filter(room => {
          const apartment = room.apartments[0];
          return (
            (!this.filters.country || apartment.country.includes(this.filters.country)) &&
            (!this.filters.county || apartment.county.includes(this.filters.county)) &&
            (!this.filters.location || apartment.location.includes(this.filters.location)) &&
            (!this.filters.city || apartment.city.includes(this.filters.city)) &&
            (!this.filters.price || parseFloat(room.price) <= parseFloat(this.filters.price)) &&
            (!this.filters.room_size || room.room_size.includes(this.filters.room_size)) &&
            (!this.filters.apartment_name || apartment.name.includes(this.filters.apartment_name)) &&
            (!this.filters.apartment_id || apartment.id == this.filters.apartment_id) &&
            (!this.filters.type || apartment.type.includes(this.filters.type))
          );
        });
      },
    },
    methods: {
      updateCounties() {
    this.selectedCounties = this.counties[this.filters.country] || [];
    this.filters.county = ''; // Reset county selection when country changes
    this.applyFilters(); // Apply filters again if needed
  },
      async fetchRooms() {
        try {
          this.loading = true;
          const params = {
            country: this.filters.country,
            county: this.filters.county,
            location: this.filters.location,
            city: this.filters.city,
            lat: this.filters.lat,
            lng: this.filters.lng,
            radius: this.filters.radius,
          };
          const response = await axios.get('http://apartments1.pacmis/api/auth/empty-rooms', { params });
          this.rooms = response.data;
          this.updateMap();
          this.loading = false;
        } catch (error) {
          console.error('Error fetching rooms:', error);
          this.loading = false;
        }
      },
      getCurrentLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            this.filters.lat = position.coords.latitude;
            this.filters.lng = position.coords.longitude;
            this.fetchRooms();
          });
        } else {
          alert('Geolocation is not supported by this browser.');
        }
      },
      addToWatchlist(roomId) {
        // Add room to watchlist logic
      },
      bookRoom(roomId) {
        // Book room logic
      },
      previousPage() {
        // Logic for previous page
      },
      nextPage() {
        // Logic for next page
      },
      applyFilters() {
        console.log('Applying filters:', this.filters);
      this.filteredRooms = this.rooms.filter(room => {
        let matches = true;

        // Check if the room matches the selected filters
        if (this.filters.country && room.country !== this.filters.country) {
          matches = false;
        }
        if (this.filters.county && room.county !== this.filters.county) {
          matches = false;
        }
        if (this.filters.location && room.location.indexOf(this.filters.location) === -1) {
          matches = false;
        }
        if (this.filters.city && room.city.indexOf(this.filters.city) === -1) {
          matches = false;
        }
        if (this.filters.price && room.price > this.filters.price) {
          matches = false;
        }
        if (this.filters.room_size && room.room_size !== this.filters.room_size) {
          matches = false;
        }
        if (this.filters.apartment_name && room.apartment_name.indexOf(this.filters.apartment_name) === -1) {
          matches = false;
        }
        if (this.filters.apartment_id && room.apartment_id !== this.filters.apartment_id) {
          matches = false;
        }
        if (this.filters.type && room.type !== this.filters.type) {
          matches = false;
        }

        return matches;
      });

      this.totalPages = Math.ceil(this.filteredRooms.length / 10); // Assuming 10 rooms per page
    },

      getRoomImage(image) {
        return image || this.defaultImage;
      },
      initMap() {
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: { lat: -1.286389, lng: 36.817223 },
          zoom: 10,
        });
        this.updateMap();
      },
      updateMap() {
        if (!this.map) {
          this.initMap();
        } else {
          this.clearMarkers();
          this.rooms.forEach(room => {
            const apartment = room.apartments[0];
            const marker = new google.maps.Marker({
              position: { lat: parseFloat(apartment.lat), lng: parseFloat(apartment.lng) },
              map: this.map,
              title: apartment.name,
            });
            this.markers.push(marker);
          });
        }
      },
      clearMarkers() {
        this.markers.forEach(marker => marker.setMap(null));
        this.markers = [];
      },
    },
    mounted() {
      this.fetchRooms();
       // Initialize selectedCounties based on the default country
  this.selectedCounties = this.counties[this.filters.country];
    },
    created() {
    this.updateCounties();
    this.fetchRooms();
  },
  };
  </script>

  <style scoped>
  .empty-rooms-page {
    display: flex;
    margin: 1rem;
    padding: 0;
    font-family: 'Arial', sans-serif;
    width: 100%; /* Make sure the container is full width */
  }
  .sidebar {
    width: 300px;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .filter-title {
    margin-bottom: 20px;
    color: #333;
  }

  .filter-input, .filter-select {
    width: 100%;
    padding: 10px;
    margin: 5px 0;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition: border 0.3s;
  }

  .filter-input:focus, .filter-select:focus {
    border-color: #007bff;
    outline: none;
  }

  .btn-location {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.3s;
  }

  .btn-location:hover {
    background-color: #0056b3;
  }

  .main-content {
    flex: 1; /* Allow the main content to take the remaining space */
    padding: 20px;
    margin-left: 0; /* Start from the far left */
  }
  .units-title {
    font-size: 24px;
    margin-bottom: 20px;
    color: #333;
  }

  .room-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
  }

  .room-card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.3s;
  }

  .room-card:hover {
    transform: translateY(-5px);
  }

  .room-carousel {
    position: relative;
  }

  .room-image {
    width: 100%;
    height: auto;
  }

  .carousel-info {
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
  }

  .room-info {
    padding: 5px 10px; /* Reduced top and bottom padding for less vertical space */
  }


  .room-price {
    font-size: 18px;
    font-weight: bold;
  }

  .price-value {
    color: #007bff;
  }

  .room-actions {
    display: flex;
    justify-content: space-between;
    padding: 15px;
  }

  .btn-watchlist, .btn-book {
    background-color: #027474;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.3s;
  }

  .btn-watchlist:hover, .btn-book:hover {
    background-color: #dbe91f;
  }

  .pagination {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }

  .btn-pagination {
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    margin: 0 5px;
    transition: background 0.3s;
  }

  .btn-pagination:hover:not(:disabled) {
    background-color: #0056b3;
  }

  .current-page {
    padding: 10px 15px;
  }

  .available-services {
    margin-top: 40px;
  }

  .services-title {
    font-size: 24px;
    margin-bottom: 20px;
    color: #333;
  }

  .service-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .map {
    height: 400px;
    margin-top: 20px;
    border-radius: 8px;
    overflow: hidden;
  }
  </style>
